import { app } from '../../../../../bootstrap/core';
import '../../../../../common/ui/signoTecSignature/signoTec';
import '../../../../../common/ui/inputForm/passwordForm/passwordForm';

import './components/components';

import { receivingSubmitRequestState } from './submitRequest.state';
import { receivingSubmitRequestComponent } from './submitRequest.component';
import {
  SubmitRequestInfoBoxItems,
  ValidationFormMessages,
} from './submitRequest.constants';

import submitRequestDownloadTemplate from './partials/submitRequest.download.tpl.html';
import submitRequestUploadTemplate from './partials/submitRequest.upload.tpl.html';
import submitRequestSubmitTemplate from './partials/submitRequest.submit.tpl.html';
import submitRequestFormButtonTemplate from './partials/submitRequest.formButton.tpl.html';

// Direct Bank Templates
import submitRequestDownloadTemplateDirectBank from './partials/directBank/submitRequest.download.tpl.html';
import submitRequestNextStepsTemplateDirectBank from './partials/directBank/submitRequest.nextSteps.tpl.html';
import submitRequestFormButtonTemplateDirectBank from './partials/directBank/submitRequest.formButton.tpl.html';

import submitRequestSetPasswordTemplate from './partials/submitRequest.setPassword.tpl.html';
import submitRequestAdditionalDocumentsTemplate from './partials/submitRequest.additionalDocuments.tpl.html';
import submitSterbeurkundeDocumentsTemplate from './partials/submitRequest.sterbeurkunde.tpl.html';
import { SignoTecService } from '../../../../../common/ui/signoTecSignature/signoTec.service';

app.config(receivingSubmitRequestState);
app.component(
  receivingSubmitRequestComponent.name,
  receivingSubmitRequestComponent,
);
app.value('submitRequestDownloadTemplate', submitRequestDownloadTemplate);
app.value('submitRequestUploadTemplate', submitRequestUploadTemplate);
app.value('submitRequestSubmitTemplate', submitRequestSubmitTemplate);
app.value('submitRequestFormButtonTemplate', submitRequestFormButtonTemplate);

// DirectBank
app.value(
  'submitRequestDownloadTemplateDirectBank',
  submitRequestDownloadTemplateDirectBank,
);
app.value(
  'submitRequestNextStepsTemplateDirectBank',
  submitRequestNextStepsTemplateDirectBank,
);
app.value(
  'submitRequestFormButtonTemplateDirectBank',
  submitRequestFormButtonTemplateDirectBank,
);

app.value('submitRequestSetPasswordTemplate', submitRequestSetPasswordTemplate);
app.value(
  'submitRequestAdditionalDocumentsTemplate',
  submitRequestAdditionalDocumentsTemplate,
);
app.value(
  'submitSterbeurkundeDocumentsTemplate',
  submitSterbeurkundeDocumentsTemplate,
);
app.constant('SubmitRequestInfoBoxItems', SubmitRequestInfoBoxItems);
app.constant('ValidationFormMessages', ValidationFormMessages);
app.service('signoTecService', SignoTecService);
